import { createSelector } from 'reselect';
const getPurposeLimitationsMemberState = createSelector((state) => state.purposeLimitations, purposeLimitations => purposeLimitations.member || {
    userId: null,
    purposeLimitations: [],
    purposeLimitationsLevels: {},
    loading: false,
    error: null,
});
export default getPurposeLimitationsMemberState;
